import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const POST_SETTING_DEFAULT = "POST_SETTING_DEFAULT";
export const POST_SETTING_REQUEST = "POST_SETTING_REQUEST";
export const POST_SETTING_SUCCESS = "POST_SETTING_SUCCESS";
export const POST_SETTING_ERROR = "POST_SETTING_ERROR";

//* ACTIONS ------------------------------------------------
export const postSettingDefault = () => ({
  type: POST_SETTING_DEFAULT,
});

export const postSettingRequest = (payload = {}, callback) => ({
  type: POST_SETTING_REQUEST,
  payload,
  callback,
});

export const postSettingSuccess = () => ({
  type: POST_SETTING_SUCCESS,
});

export const postSettingError = (error) => ({
  type: POST_SETTING_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const postSettingServiceRequest = async (data) => {
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data,
  });

  return request("/settings", options);
};
